import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import { API_BASE } from '../../config';
import { readTemplateResponse, startTemplateDeckPolling, requestTemplateResponse } from './templateDeckPolling.mjs';
import DeckBuildActivity from './DeckBuildActivity';
import '../DeckAssembler.linear.css';

// The editor needs a published composition. Until then, show its build workspace.
export default function TemplateDeckBuild({ deckId }) {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [deck, setDeck] = useState(null);
  const [connection, setConnection] = useState(null);
  const [openError, setOpenError] = useState('');
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    let opened = false;
    const controller = new AbortController();
    setConnection(null); setOpenError('');
    const request = async (path, options = {}) => readTemplateResponse(await requestTemplateResponse(
      `${API_BASE}${path}`, { ...options, signal: controller.signal,
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' } }));
    const stop = startTemplateDeckPolling(async () => (await request(`/api/template-decks/${deckId}`)).json(),
      async value => {
        if (!active) return;
        setDeck(value);
        if (value.status !== 'ready' || opened) return;
        opened = true;
        try {
          const result = value.composition_id ? value : await (await request(`/api/template-decks/${deckId}/open`, { method: 'POST' })).json();
          if (!Number.isInteger(result.composition_id) || result.composition_id <= 0) throw new Error('Saved workspace unavailable.');
          if (active) navigate(`/decks/meeting-prep?composition=${result.composition_id}`, { replace: true });
        } catch (failure) { if (active) setOpenError(failure.message); }
      }, (message, info) => { if (active) setConnection(message ? { message, ...info } : null); });
    return () => { active = false; stop(); controller.abort(); };
  }, [deckId, token, navigate, attempt]);
  return <div className="dk dk-build-workspace">
    <header className="dk-build-toolbar">
      <div><h1>{deck?.title || 'Your presentation'}</h1><p>Meeting Prep</p></div>
      <button type="button" className="dk-btn" onClick={() => navigate('/')}>Back to chat</button>
    </header>
    <main className="dk-build-canvas">
      <DeckBuildActivity activity={deck?.activity} status={deck?.status} connection={connection}
        openError={openError} onRetry={() => setAttempt(value => value + 1)} />
    </main>
  </div>;
}
